import React, { useEffect, useState, useContext } from 'react'
import './App.css'
import { genNewTokenAPI } from './apis/APIs'
import { PlanCheckDialog, ShowSnackbar } from './controller/BaseTool'
import { LoginValidate, Logout } from './controller/caller'
import { Env } from './controller/constant'
import axios from 'axios'
import './App.css'
import { Buffer } from 'buffer'
import { isMobile } from 'react-device-detect'
import './messaging_init_in_sw'
import { initializeApp } from 'firebase/app'
import { getMessaging, onMessage } from 'firebase/messaging'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { WtUrl } from './constants/urls'
import { WtColor } from './constants/colours'
import { getLoggedUserInfo, showConsole } from './basetool/methods'
import { WtLoginKey } from './constants/loginKeys'
import { RouteController } from './routes/routes'
import globalContext from './context/global/globalContext'


// Axios Work
let reqLs = {}
axios.interceptors.request.use((request) => {
  let reqId = request.url.replace(Env.baseApiCallURL, '') + JSON.stringify({ method: request.method, payload: request.data }).split('').sort().join('');
  if (reqLs[`${reqId}`] === true) { return undefined }
  reqLs[`${reqId}`] = true

  let token_gen = String(Number(Date.now()))
  token_gen = Buffer.from(token_gen).toString("base64").slice(0, -2)
  token_gen = token_gen.split("").reverse().join("")

  showConsole('📣 Request: ' + request.method + ' ' + request.url.replace(Env.baseApiCallURL, '') + ' ' + JSON.stringify(request.data))

  request.headers["token"] = token_gen
  if (getLoggedUserInfo(WtLoginKey.authToken)) request.headers["authorization"] = getLoggedUserInfo(WtLoginKey.authToken)
  if (getLoggedUserInfo(WtLoginKey.businessId)) request.headers["bid"] = getLoggedUserInfo(WtLoginKey.businessId)
  if (getLoggedUserInfo(WtLoginKey.userEmail)) request.headers["empemail"] = getLoggedUserInfo(WtLoginKey.userEmail)
  request.headers["devicetype"] = isMobile ? "mobile_web" : "desktop_web"
  request.reqId = reqId

  return request
}, (error) => { return Promise.reject(error) })

axios.interceptors.response.use(
  (response) => {
    delete reqLs[`${response.config.reqId}`]

    showConsole('🟢 Success: ' + response.config.method + ' ' + response.config.url.replace(Env.baseApiCallURL, '') + ' ' + response.status)
    return response;
  },
  (error) => {
    const response = error.response;
    delete reqLs[`${response.config.reqId}`]

    showConsole('🔴 Failure: ' + response.config.method + ' ' + response.config.url.replace(Env.baseApiCallURL, '') + ' ' + response.status)

    return Promise.reject(error)
  }
)
// End of Axios Work


function App() {
  const handleNotificationBarStatus = useContext(globalContext)
  const notificationBarData = useContext(globalContext)
  const handleNotificationBarData = useContext(globalContext)


  // Snackbar Code
  const [errorMsg, setErrorMsg] = useState("")
  const [errorMsgBg, setErrorMsgBg] = useState(WtColor.RedColor)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const SnackbarShow = (errorMsg, errorMsgBg) => {
    setErrorMsg(errorMsg)
    setErrorMsgBg(errorMsgBg)
    setOpenSnackbar(true)
  }
  const SnackbarClose = () => setOpenSnackbar(false)
  // End of Snackbar Code


  // Generate New Auth Token
  const genNewToken = async () => {
    let busy = false
    if (!busy) {
      busy = true
      try {
        if (getLoggedUserInfo(WtLoginKey.authToken)) {
          const response = await genNewTokenAPI()
          if (response.status === 200) {
            let data = getLoggedUserInfo(WtLoginKey.userInfo)
            data.authToken = response?.data?.data?.authToken
            localStorage.setItem('uInfo', JSON.stringify(data))
            if (localStorage.getItem('isDemo') === "false") localStorage.setItem('uInfoBup', JSON.stringify(data))

            // Handle Topbar Notification Information
            if (response?.data?.data?.headerInfo && notificationBarData.notificationBarData === undefined) {
              handleNotificationBarStatus.handleNotificationBarStatus(response?.data?.data?.headerInfo?.view) // boolean
              handleNotificationBarData.handleNotificationBarData(response?.data?.data?.headerInfo) // headerInfo as data_obj
            }
            // End of Handle Topbar Notification Information
          }
          if (response.status === 402) Logout()
        }
      } catch (error) { }
    }
  }
  useEffect(() => { genNewToken() })
  // End of Generate New Auth Token


  // Plan Check Dialog
  const [openPlanCheckDialog, setPlanCheckDialog] = useState({ open: false, onClose: null, })
  // End of Plan Check Dialog


  // Axios Work
  axios.interceptors.response.use(
    (response) => {
      let status = response?.status;
      if (status === 200 && response.data.message !== "Success" && response.config.url !== 'http://ip-api.com/json') SnackbarShow(response.data.message, WtColor.BaseColor)
      if (status === 201) SnackbarShow(response.data.message, WtColor.BaseColor)
      if (status === 202) SnackbarShow(response.data.message, WtColor.BaseColor)
      if (status === 204) SnackbarShow("Delete Successfully", WtColor.BaseColor)
      return response;
    },
    (error) => {
      if (error?.response?.status === 500) SnackbarShow("Internal Server Error", WtColor.RedColor)
      if (error?.response?.status === 501) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 510) {
        if (Env.env_type !== 'production') {
          showConsole(error.response.data.message)
          SnackbarShow(error.response.data.message, WtColor.RedColor)
        } else {
          SnackbarShow("Something went wrong!!!", WtColor.RedColor)
        }
      }
      if (error?.response?.status === 400) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 401) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 402) Logout()
      if (error?.response?.status === 403 && error?.response.config.url !== "http://ip-api.com/json") SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 404) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 405) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 406) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 409) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 410) SnackbarShow(error.response.data.message, WtColor.RedColor)
      if (error?.response?.status === 426) {
        SnackbarShow(error.response.data.message, WtColor.RedColor)
        setPlanCheckDialog({ open: true, purpose: "upgradeRequired", errorMsg: error.response.data.message, onClose: () => setPlanCheckDialog(false) })
      }

      if (error?.response?.status === 429) {
        SnackbarShow(error.response.data.message, WtColor.RedColor)
        setPlanCheckDialog({ open: true, purpose: "limitExceed", errorMsg: error.response.data.message, onClose: () => setPlanCheckDialog(false) })
      }

      return Promise.reject(error)
    }
  )
  // End of Axios Work


  // Chat Notification Work
  if (LoginValidate()) {
    const app = initializeApp(Env.firebaseConfig)
    const messaging = getMessaging(app)
    onMessage(messaging, (payload) => {
      if (LoginValidate() && !window.location.href.startsWith(Env.baseUI_URL + WtUrl.chatUrl)) {
        toast(<ToastifyNotification payload={payload} />)
      }
    })
    const notiticlick = (hash) => {
      localStorage.setItem('notificationClicked', 'true')
      window.location.href = Env.baseUI_URL + WtUrl.chatUrl + '/' + hash
    }

    const ToastifyNotification = ({ payload }) => (
      <div className="push-notification" onClick={() => notiticlick(payload?.data?.hash)}>
        <h6 className="push-notification-title" style={{ fontWeight: "bold", color: WtColor.TextDarkColor }}>{payload?.notification?.title}</h6>
        <p className="push-notification-text" style={{ color: WtColor.TextMidGrey }}>
          {payload?.notification?.body}
        </p>
      </div>
    )
  }
  // End of Chat Notification Work


  useEffect(() => {
    if (LoginValidate()) {
      if (!localStorage.getItem("userActivity")) localStorage.setItem("userActivity", "false")
      if (!localStorage.getItem("botLeftSidebar")) localStorage.setItem("botLeftSidebar", "false")
      if (!localStorage.getItem("isDemo")) localStorage.setItem("isDemo", false)
    }
  }, [])
  return (
    <>
      <RouteController />
      <ShowSnackbar open={openSnackbar} errorMsg={errorMsg} errorMsgBg={errorMsgBg} close={SnackbarClose} />
      <PlanCheckDialog open={openPlanCheckDialog.open} purpose={openPlanCheckDialog.purpose} errorMsg={openPlanCheckDialog.errorMsg} onClose={openPlanCheckDialog.onClose} />
      <ToastContainer hideProgressBar={true} autoClose={6000} />
    </>
  )
}

export default App